import tw, { styled } from 'twin.macro';

export const StyledBody = styled.article`
	${tw`divide-gray-200 divide-y overflow-y-auto`}
`;
